import { useState } from 'react';
import { toast } from 'sonner';
import { Loader2, Send, CheckCircle2 } from 'lucide-react';
import { publicPost } from '../../lib/publicApi';

export default function ContactForm({ propertyId }) {
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error('Merci de remplir tous les champs');
      return;
    }
    setSubmitting(true);
    try {
      await publicPost('/api/public/contact', { ...form, property_id: propertyId });
      setSent(true);
      toast.success('Message envoyé ! Nous vous répondons dans quelques instants.');
    } catch (e) {
      toast.error(e.message || 'Erreur lors de l\'envoi');
    } finally {
      setSubmitting(false);
    }
  };

  if (sent) {
    return (
      <div className="text-center py-12 animate-fade-in" data-testid="contact-sent">
        <CheckCircle2 className="w-12 h-12 mx-auto text-[#D4AF37] mb-4" strokeWidth={1.2} />
        <h3 className="font-display text-3xl mb-3">Merci !</h3>
        <p className="font-body font-light text-[#A39E93]">Votre message est bien arrivé. Nous vous répondrons par email ou téléphone très rapidement.</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
      <div className="grid md:grid-cols-2 gap-4">
        <input
          type="text" required placeholder="Votre nom"
          value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
          className="w-full bg-[#141312] border border-white/10 focus:border-[#D4AF37] py-4 px-4 font-body text-sm text-[#F5F2EB] outline-none transition-colors placeholder-[#5C5851]"
          data-testid="contact-name"
        />
        <input
          type="email" required placeholder="Votre email"
          value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
          className="w-full bg-[#141312] border border-white/10 focus:border-[#D4AF37] py-4 px-4 font-body text-sm text-[#F5F2EB] outline-none transition-colors placeholder-[#5C5851]"
          data-testid="contact-email"
        />
      </div>
      <input
        type="tel" placeholder="Téléphone (optionnel)"
        value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })}
        className="w-full bg-[#141312] border border-white/10 focus:border-[#D4AF37] py-4 px-4 font-body text-sm text-[#F5F2EB] outline-none transition-colors placeholder-[#5C5851]"
        data-testid="contact-phone"
      />
      <textarea
        rows={4} required placeholder="Votre question, votre projet... nous vous répondons rapidement."
        value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })}
        className="w-full bg-[#141312] border border-white/10 focus:border-[#D4AF37] py-4 px-4 font-body text-sm text-[#F5F2EB] outline-none transition-colors placeholder-[#5C5851] resize-none"
        data-testid="contact-message"
      />
      <button
        type="submit" disabled={submitting}
        className="btn-luxury w-full"
        data-testid="contact-submit"
      >
        {submitting ? <Loader2 className="w-4 h-4 animate-spin" /> : <>Envoyer ma question <Send className="ml-3 w-4 h-4" /></>}
      </button>
      <p className="text-xs text-[#5C5851] font-body text-center">Réponse sous quelques minutes pendant les heures d'activité.</p>
    </form>
  );
}
